import { useAuth } from '@auth/useAuth'
import { Adornment, listTenantMemberAdornments } from '@kudos/http-client'
import { useQuery } from '@tanstack/react-query'
import { format } from 'date-fns'

export const MEMBER_ADORNMENTS_QK = 'tenantMemberAdornments'

const useMemberAdornments = (memberId: string | undefined | null): Adornment | null => {
  const { tenantId, isAuthenticated } = useAuth()
  const day = format(new Date(), 'yyyy-MM-dd')

  const { data } = useQuery({
    // tenantId prevents serving another tenant's adornments after a same-session switch
    queryKey: [MEMBER_ADORNMENTS_QK, tenantId, day],
    queryFn: () => listTenantMemberAdornments({ day }),
    staleTime: 1000 * 60 * 15, // 15 min — matches backend cache TTL
    // This endpoint is user-scoped (plain `API`, not `TV_API`), so it 401s on any
    // surface without a signed-in user — notably Kudos TV, which authenticates by
    // device code. `staleTime` does not apply to an errored query and `retryOnMount`
    // defaults to true, so without this gate every remount re-issues the request
    // forever. See SYN-8267.
    enabled: !!memberId && isAuthenticated,
  })

  if (!memberId) return null
  const adornment = data?.[memberId] ?? null
  return adornment
}

export default useMemberAdornments
